import { Component } from '@angular/core';
import { AbstractWidgetComponent } from '@sdbn/common';
import { WidgetStyle } from '@sdbn/common';

@Component({
  selector: 'app-equipment-admin-widget',
  templateUrl: './equipment-admin-widget.component.html',
  styleUrls: ['./equipment-admin-widget.component.scss']
})
export class EquipmentAdminWidgetComponent extends AbstractWidgetComponent {

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }
}
